import {FieldDate, FieldInput} from "@kroschke/react-ui";
import {FieldDualInput, FormSection} from "../../../ui";
import {
    VdaDocumentDefaultBaseProps,
    VdaDocumentDefaultFormData,
    VdaDocumentDefaultValidation
} from "./VdaDocumentDefaultForm";
import {ReactNode} from "react";


export interface VdaDocumentCor1FormData extends VdaDocumentDefaultFormData {
    corSerial: string
    licensePlate: string
    registrationDateFirst?: string
    registrationDateLatest?: string
    deregistrationDate?: string
    vinCheckDigit?: string
}

export interface VdaDocumentCor1Validation extends VdaDocumentDefaultValidation {
    corSerial?: string
    licensePlate?: string
    registrationDateFirst?: string
    registrationDateLatest?: string
    deregistrationDate?: string
    vinCheckDigit?: string
}

export interface VdaDocumentCor1FormProps extends VdaDocumentDefaultBaseProps {
    validation: VdaDocumentCor1Validation,
    value: VdaDocumentCor1FormData
    onChange: (value: VdaDocumentCor1FormData) => any
    onBlur: () => any,
    disableLicensePlate: boolean
    header: ReactNode
}

export function VdaDocumentCor1Form({
                                        value,
                                        disabled,
                                        disableLicensePlate,
                                        onChange,
                                        onBlur,
                                        validation,
                                        label,
                                        header
                                    }: VdaDocumentCor1FormProps) {

    return <FormSection
        label={label}
        header={header}
        children={
            <>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldDualInput
                            label={"Fahrgestellnummer | Prüfziffer"}
                            invalid={Boolean(validation.vinCheckDigit)}
                            disabledLeft={true}
                            disabledRight={disabled}
                            help={validation.vinCheckDigit}
                            value={{
                                left: value.vin,
                                right: value.vinCheckDigit
                            }}
                            onChange={v => {
                                onChange({
                                    ...value,
                                    vinCheckDigit: v.right
                                })
                            }}
                            onBlur={() => !disabled && onBlur()}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"ZB1 Nummer"}
                            required={true}
                            maxLength={20}
                            help={validation.corSerial}
                            invalid={Boolean(validation.corSerial)}
                            inputTransform={e => e.toUpperCase()}
                            value={value.corSerial}
                            onBlur={() => !disabled && onBlur()}
                            onChange={corSerial => {
                                onChange({
                                    ...value,
                                    corSerial: corSerial
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled || disableLicensePlate}
                            label={"Kennzeichen"}
                            help={validation.licensePlate}
                            invalid={Boolean(validation.licensePlate)}
                            value={value.licensePlate}
                            onBlur={() => !disabled && onBlur()}
                            inputTransform={e => e.toUpperCase()}
                            onChange={licensePlate => {
                                onChange({
                                    ...value,
                                    licensePlate: licensePlate
                                })
                            }}
                        />
                    </div>
                </div>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldDate
                            disabled={disabled}
                            label={"Erstzulassungsdatum"}
                            help={validation.registrationDateFirst}
                            invalid={Boolean(validation.registrationDateFirst)}
                            value={value.registrationDateFirst}
                            onBlur={() => !disabled && onBlur()}
                            onChange={registrationDateFirst => {
                                onChange({
                                    ...value,
                                    registrationDateFirst: registrationDateFirst
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldDate
                            disabled={disabled}
                            label={"Zulassungsdatum (aktuell)"}
                            help={validation.registrationDateLatest}
                            invalid={Boolean(validation.registrationDateLatest)}
                            value={value.registrationDateLatest}
                            onBlur={() => !disabled && onBlur()}
                            onChange={registrationDateLatest => {
                                onChange({
                                    ...value,
                                    registrationDateLatest: registrationDateLatest
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldDate
                            disabled={disabled}
                            label={"Abmeldedatum"}
                            help={validation.deregistrationDate}
                            invalid={Boolean(validation.deregistrationDate)}
                            value={value.deregistrationDate}
                            onBlur={() => !disabled && onBlur()}
                            onChange={deregistrationDate => {
                                onChange({
                                    ...value,
                                    deregistrationDate: deregistrationDate
                                })
                            }}
                        />
                    </div>
                </div>
                <div className={"columns"}>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Dokumenten-Id"}
                            required={true}
                            help={validation.documentId}
                            invalid={Boolean(validation.documentId)}
                            value={value.documentId}
                            onBlur={() => !disabled && onBlur()}
                            onChange={documentID => {
                                onChange({
                                    ...value,
                                    documentId: documentID
                                })
                            }}
                        />
                    </div>
                    <div className={"column is-one-third"}>
                        <FieldInput
                            disabled={disabled}
                            label={"Position"}
                            required={true}
                            help={validation.position}
                            invalid={Boolean(validation.position)}
                            value={`${value.position}`}
                            onBlur={() => !disabled && onBlur()}
                            onChange={position => {
                                onChange({
                                    ...value,
                                    position: parseInt(position) || 0
                                })
                            }}
                        />
                    </div>
                </div>
            </>
        }
    />
}
